<template>
	<div>
		<Bg :isMobile='isMobile' />
		<Mobile v-if="isMobile" />
		<Pc v-else />
	</div>
</template>

<script>
	import '@/assets/css/public.css';
	import Bg from '@/components/Bg.vue'
	import Pc from '@/components/Pc.vue'
	import Mobile from '@/components/Mobile.vue'

	export default {
		data() {
			return {
				isMobile: undefined
			}
		},
		created() {

		},
		mounted() {
			this.set()
			window.onresize = () => {
				return (() => {
					this.set()
				})()
			}
		},
		computed: {},
		watch: {},
		methods: {
			set() {
				if (document.body.clientWidth < 768) {
					this.isMobile = true
					document.documentElement.style.fontSize = 100 + 'px';
				} else {
					this.isMobile = false
				}
			}
		},
		components: {
			Bg,
			Pc,
			Mobile
		}
	}
</script>

<style scoped lang="less">

</style>
